import { Typography } from '@design-system';
import { Quitus } from '@services';
import './QuitusCard.scss';
import { QuitusStatusProvider } from './QuitusStatusProvider';

export const QuitusCard: React.FC<{ quitus: Quitus }> = ({ quitus }) => {
    return (
        <div className="quitus-card">
            <div className="quitus-card-container">
                <div className="quitus-card-header-left">
                    <QuitusStatusProvider status={quitus.status} />
                </div>
                <div className="quitus-card-header-right">
                    <Typography intrinsic="h4" color="marine" defaultSpacing>
                        {quitus.title}
                    </Typography>

                    <Typography intrinsic="p" color="grey" defaultSpacing>
                        {quitus.apartment}
                    </Typography>
                </div>
            </div>
        </div>
    );
};
